import React, { useRef, useState } from 'react';
import { Alert, Button, Form } from 'react-bootstrap';
import {useSelector} from 'react-redux';
import useCommerceScope from '../utils/useCommerceScope';
import { commerce } from '../api/commerce';
import { commerceError, evidenceReferences } from '../utils/commerce';

export default function RefundReferences({ refundId,onSubmitted }) {
    const [requested, setRequested] = useState(false);
    const [references, setReferences] = useState('');
    const [busy, setBusy] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const user=useSelector(state=>state.auth.user);const {current}=useCommerceScope(user);
    const guard = useRef(false);
    const submit = async event => {
        event.preventDefault();
        if (!requested || guard.current) return;
        if(user?.phoneVerified!==true){setError('Verify your phone before submitting references.');return;}
        guard.current = true;
        setBusy(true); setError(''); setMessage('');
        try {
            const values = evidenceReferences(references);
            if (!values.length) throw new Error('Enter the references requested by support.');
            await commerce.refundDocuments(refundId, { evidenceReferences: values });
            if(!current())return;
            setMessage('Additional references received.');
            setReferences(''); setRequested(false);await onSubmitted?.();
        } catch (failure) { if(current())setError(commerceError(failure)); }
        finally { guard.current = false;if(current())setBusy(false); }
    };
    return <Form onSubmit={submit} className="mt-3">
        <Form.Check id={`support-request-${refundId}`} checked={requested} disabled={busy}
            label="Support has asked me to provide additional evidence references"
            onChange={event => setRequested(event.target.checked)} />
        {requested && <><Form.Group controlId={`support-references-${refundId}`}>
            <Form.Label>Requested text references, one per line (up to 20; 1000 characters each)</Form.Label>
            <Form.Control as="textarea" value={references} disabled={busy} onChange={event => setReferences(event.target.value)} />
        </Form.Group><Button type="submit" disabled={busy}>Send requested references</Button></>}
        <div aria-live="polite">{error && <Alert variant="danger">{error}</Alert>}{message && <Alert variant="info">{message}</Alert>}</div>
    </Form>;
}
